module.exports = __webpack_public_path__ + "static/assets/0af4f18c7b16bff354edaf9a66edd265.png";